/**
 * @description Status as per MPX metadata.status field
 */
export enum MPXStatus {
	AVAILABLE = 'AVAILABLE',
	DELAYED = 'DELAYED',
	EXPIRED = 'EXPIRED',
	PREMIUM = 'PREMIUM',
	PREMIUM_EST = 'PREMIUM_EST',
}